import React from "react";

function AdminDocuments() {
  return <div>AdminDocuments</div>;
}

export default AdminDocuments;
